module.exports = __webpack_public_path__ + "static/media/cadence-board.474eada1.svg";